// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__2wSvP","Logo__Image":"Logo_Logo__Image__2_4UK","Logo__Image--compact":"Logo_Logo__Image--compact__1anWT","Logo__Image--fluid":"Logo_Logo__Image--fluid__2p1IK"};